import { render, staticRenderFns } from "./teacherInfo.vue?vue&type=template&id=6a367198&scoped=true"
import script from "./teacherInfo.vue?vue&type=script&lang=js"
export * from "./teacherInfo.vue?vue&type=script&lang=js"
import style0 from "./teacherInfo.vue?vue&type=style&index=0&id=6a367198&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a367198",
  null
  
)

export default component.exports